// Inline constant to avoid importing from @github-ui/filter-core/providers
const AT_COPILOT_VALUE = '@copilot'

/**
 * Checks if the comment body mentions @copilot
 * Matches: @copilot, @Copilot, or any case variation when followed by whitespace or punctuation
 */
const COPILOT_MENTION_PATTERN = new RegExp(`(^|[\\s])${AT_COPILOT_VALUE}([^\\w-]|$)`, 'i')

export function mentionsCopilot(text: string): boolean {
  // Match @copilot at start of string or after whitespace, followed by non-word character or end of string
  // Use AT_COPILOT_VALUE constant to ensure consistency across the codebase
  return COPILOT_MENTION_PATTERN.test(text)
}
